module.exports = __webpack_public_path__ + "b563740227cacc9160bc3f569e3d9b1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/images/works/onepage_slide_pipilotti_2.jpg
// module id = 227
// module chunks = 0